/* global _satellite */
'use strict';

require('../../icons/spinner_34px.svg');
var debounce = require('lodash/debounce');
var util = require('../utilities/util');
var endpoint = $('.suggestions-wrapper').data('url');
var endpointsavesuggestions = $('.suggestions-wrapper').data('savesuggestions');
var endpointfetchsuggestions = $('.suggestions-wrapper').data('fetchsuggestions');
var minBytes = 3;
var counterForLazyLoad = 0;
let mobileMediaQuery = window.matchMedia('(max-width: 1023px)');
var searchTermSubmitted = true;
var registereduser = $('.suggestions').data('registereduser');
var fetchRecentSearchFlag = true;


var pdSwiperFilter = require('../components/pdSwiperFilter');
var lazyLoadConfigs = $('body').find('.lazy-load-configs');

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    if (!$('.suggestions-wrapper').is(':visible')) {
        return $(scope).siblings('.suggestions-wrapper-new');
    }
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Updates the number of items value above the 'See More' button.
 */
function setMoreNumberOfItems() {
    var updatedProductItems = $('.product-grid .product-tile').length;
    $('.cdp-current-count').html(updatedProductItems);
    setTimeout(function () {
        $('.js-cdp-current-count').html(
            updatedProductItems + ' ' + $('.label-of').html() + ' ' + $('.cdp-total-count').html()
        );
    }, 1000);
}
/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body.type-ahead-suggestions').removeClass(
        'modal-open type-ahead-suggestions'
    );
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open type-ahead-suggestions');
        if (!$('.suggestions-wrapper').is(':visible')) {
            getSuggestionsWrapper(scope)
            .find('.search-suggestions-wrapper')
            .addClass('modal');
        } else {
            getSuggestionsWrapper(scope)
            .find('.suggestions')
            .addClass('modal');
        }
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    clearModals();
    $('.search-mobile .suggestions').off('scroll');
    if (!$('.suggestions-wrapper').is(':visible')) {
        $('.search-suggestions-wrapper').empty();
        $('.search-suggestions-wrapper').removeClass('modal');
        $('.default-suggestions-wrapper').removeClass('d-none');
        $('.newSearch').find('.search-field').attr('aria-expanded', 'true');
    } else {
        $('.suggestions-wrapper').empty();
    }
    if ($('#global-search-field').length > 0) {
        $('[id=global-search-field]').attr('aria-expanded', 'false');
    }
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile span.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch)
            .removeClass(iconSearch)
            .addClass(iconSearchClose);
    } else {
        $(mobileSearchIcon + iconSearchClose)
            .removeClass(iconSearchClose)
            .addClass(iconSearch);
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (
        $(scope).scrollTop() + $(scope).innerHeight() >=
        $(scope)[0].scrollHeight
    ) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;
    var calculatedHeight;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        calculatedHeight = 'calc(100% - ' + (top + outerHeight) + 'px)';
        if ($('.suggestions-wrapper').is(':visible')) {
            $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        } else {
            $suggestions = getSuggestionsWrapper(scope).find('.search-suggestions-wrapper').find('.suggestions');
        }
        $suggestions.css({
            top: top + outerHeight,
            bottom: 0,
            'max-height': calculatedHeight
        });

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper;
    if (!$('.suggestions-wrapper').is(':visible')) {
        $suggestionsWrapper = getSuggestionsWrapper(this).find('.search-suggestions-wrapper').empty();
        $('.default-suggestions-wrapper').addClass('d-none');
    } else {
        $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    }

    if (typeof response !== 'object') {
        $suggestionsWrapper.append(response).show();
        if (!$('.suggestions-wrapper').is(':visible')) {
            $('.loader-section').removeClass('d-none');
            $('.do-you-mean').attr('tabindex', '-1');
            $('.search-suggestions-wrapper .categories-header .category, .search-suggestions-wrapper .categories a, .search-suggestions-wrapper .popular-results-header div, .search-suggestions-wrapper .popular-results-items a').attr('tabindex', '-1');
            $('.search-suggestions-wrapper .recent-results-header .col-12, .search-suggestions-wrapper .recent-results-items a').attr('tabindex', '-1');
        }
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
            $suggestionsWrapper.show();
        }
        setTimeout(function () {
            $('.did-you-mean').removeClass('d-none');
            if (!$('.suggestions-wrapper').is(':visible')) {
                $('.loader-section').addClass('d-none');
            }
            $('.suggestions .products').removeClass('d-none');
        }, 600);
    } else if (!$('.suggestions-wrapper').is(':visible')) {
        $('.suggestions-wrapper-new').hide();
    } else {
        $('.suggestions').hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var searchString = $(scope).val();
    var totalBytes;

    try {
        totalBytes = util.byteLengthOf(searchString);
    } catch (e) {
        totalBytes = searchString.length;
    }
    $.cookie('searchTerm', encodeURIComponent(searchString), { expires: 365, path: '/' });
    if (totalBytes >= minBytes) {
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        clearModals();
        if (!$('.suggestions-wrapper').is(':visible')) {
            $('.search-suggestions-wrapper').empty();
            $('.search-suggestions-wrapper').removeClass('modal');
            $('.default-suggestions-wrapper').removeClass('d-none');
            $('.newSearch').find('.search-field').attr('aria-expanded', 'true');
        } else {
            getSuggestionsWrapper(scope).empty();
        }
    }
}

/**
 * Adds products on CDP by lazy loading
 *
 */
function lazyLoadProducts() {
    var seeMoreURL;
    var index;
    var updatedURL;
    var productstolazyload = lazyLoadConfigs.data('productstolazyloaddesktop');
    var noofpagestolazyload = lazyLoadConfigs.data('noofpagestolazyload');
    if (mobileMediaQuery.matches) {
        productstolazyload = lazyLoadConfigs.data('productstolazyloadmobile');
    }
    if (counterForLazyLoad < noofpagestolazyload) {
        seeMoreURL = $('.see-more-button').data('url');
        index = seeMoreURL.indexOf('sz');
        if (index) {
            updatedURL = seeMoreURL.substring(0, index + 3) + productstolazyload;
            $('.see-more-button').data('url', updatedURL);
        }
        $('body').find('.see-more-button').click();
        counterForLazyLoad++;
        setMoreNumberOfItems();
    }
}

/**
 * Fetaching and displaying recent and popular searches
 *
 */
function fetchStoredRecentPopularSearches() {
    fetchRecentSearchFlag = false;
    $('.site-search').addClass('new-search-enabled');
    $.ajax({
        url: endpoint,
        method: 'GET',
        success: function (response) {
            if (typeof response !== 'object') {
                $('.default-suggestions-wrapper').append(response).show();
                if ($('.default-recent-searches ul li').length === 0) {
                    $('.default-recent-searches .col-7, .clear-all-recent').attr('tabindex', '-1');
                }
                if (isMobileSearch(this)) {
                    toggleSuggestionsIcon('close');
                    applyModals(this);
                }
            } else if (!$('.suggestions-wrapper').is(':visible')) {
                $('.suggestions-wrapper-new').hide();
            } else {
                $('.suggestions').hide();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
    var searchRecentTerms = localStorage.getItem('searchRecentTerms');
    var searchRecentTermLink;
    var serachFormAction = $('.site-search form').attr('action');
    if (typeof (searchRecentTerms) !== 'undefined' && searchRecentTerms !== '' && searchRecentTerms !== null) {
        $('.default-recent-searches').removeClass('d-none');
        var array = searchRecentTerms.split('||').map(function (s) {
            return s.trim();
        }).filter(function (v, i, a) {
            return a.indexOf(v) === i;
        }).join(',')
        .split(',');
        $.each(array, function (index, value) {
            searchRecentTermLink = serachFormAction + '?q=' + encodeURIComponent(value);
            if (index <= 4 && value !== '') {
                $('.default-suggestions-wrapper .items').append('<li><a data-lulu-track="search-suggestion-modal-link" tabindex="0" href="' + searchRecentTermLink + '">' + value + '</a></li>');
            }
        });
    } else if (registereduser) {
        $.ajax({
            url: endpointfetchsuggestions,
            method: 'GET',
            success: function (response) {
                if (response.data) {
                    var savedSuggestions = searchRecentTerms.split('||').map(function (s) {
                        return s.trim();
                    }).filter(function (v, i, a) {
                        return a.indexOf(v) === i;
                    }).join(',')
                    .split(',');
                    if (savedSuggestions) {
                        $.each(savedSuggestions, function (index, value) {
                            searchRecentTermLink = serachFormAction + '?q=' + encodeURIComponent(value);
                            if (index <= 5 && value !== '') {
                                $('.default-suggestions-wrapper .items').append('<li><a data-lulu-track="search-suggestion-modal-link" tabindex="0" href="' + searchRecentTermLink + '">' + value + '</a></li>');
                            }
                        });
                    }
                } else {
                    $('.default-recent-searches').addClass('d-none');
                }
            },
            error: function () {
                $.spinner().stop();
                $('.default-recent-searches').addClass('d-none');
            }
        });
    } else {
        $('.default-recent-searches').addClass('d-none');
    }
}

// Adding/removing page overlay during and after search
$(document).ready(function () {
    if ($('.newSearch').length > 0) {
        if (!$('.suggestions-wrapper').is(':visible')) {
            setTimeout(function () {
                if (fetchRecentSearchFlag) {
                    fetchStoredRecentPopularSearches();
                }
            }, 1000);
        }
        $(document).on('click', '#accept-recommended-btn-handler, #onetrust-accept-btn-handler, .save-preference-btn-handler', function () {
            setTimeout(function () {
                if (!$('.suggestions-wrapper').is(':visible') && fetchRecentSearchFlag) {
                    fetchStoredRecentPopularSearches();
                }
            }, 1000);
        });
        $('.newSearch').focusin(function () {
            $('.overlay-div').removeClass('d-none');
            $('.newSearch').addClass('focused');
            $('.header-banner-container').addClass('search-modal-open');
            if (!$('.suggestions-wrapper').is(':visible') && $(this).find('.form-control.search-field').val().length >= 3) {
                $('.default-suggestions-wrapper').addClass('d-none');
                $('.newSearch').find('.search-field').attr('aria-expanded', 'false');
            }
            if (!$('.suggestions-wrapper').is(':visible')) {
                $('.suggestions-wrapper-inner').removeClass('d-none');
                $('.newSearch').find('.search-field').attr('aria-expanded', 'true');
                if (fetchRecentSearchFlag) {
                    fetchStoredRecentPopularSearches();
                }
            }
            if (!$('.suggestions-wrapper').is(':visible') && $(this).find('.form-control.search-field').val().length < 3) {
                $('.default-suggestions-wrapper .suggestions').show();
            }
        });

        $('.newSearch').focusout(function () {
            $('.overlay-div').addClass('d-none');
            $('.newSearch').removeClass('focused');
            $('.header-banner-container').removeClass('search-modal-open');
        });
    }

    $(window).on('orientationchange', function () {
        clearModals();
        $('.cross-icon-button').trigger('click');
        tearDownSuggestions();
    });

    $(document).on('click', '.default-recent-searches a', function () {
        var termSuggested;
        var listCount;
        var listPosition;
        listPosition = Array.from($(this).closest('.items').find('a')).indexOf(this) + 1;
        listCount = Array.from($(this).closest('.items').find('a')).length;
        termSuggested = $(this).text();

        _satellite.track('search-execute', {
            termQueried: '', // leave empty string
            termSuggested: termSuggested,
            listCount: listCount,
            listPosition: listPosition,
            label: 'navbox-typeahead-recent-search-term'
        }
        );
    });

    $(document).on('click', '.default-suggestions-wrapper .suggestions a', function () {
        var termSuggested;
        var listCount;
        var listPosition;
        listPosition = Array.from($(this).closest('.popular-results-items').find('a')).indexOf(this) + 1;
        listCount = Array.from($(this).closest('.popular-results-items').find('a')).length;
        termSuggested = $(this).text();

        _satellite.track('search-execute', {
            termQueried: '', // leave empty string
            termSuggested: termSuggested,
            listCount: listCount,
            listPosition: listPosition,
            label: 'navbox-typeahead-popular-search-term'
        }
        );
    });

    // Retrieve the array from local storage
    var dismissedPages = JSON.parse(window.localStorage.getItem('quiz-toaster-dismissed-pages') || '[]');

    // Check if the current page is in the array
    var currentPage;
    if (window.digitalData.page.category.subCategory2 !== '') {
        currentPage = window.digitalData.page.category.subCategory2;
    } else if (window.digitalData.page.category.subCategory1 !== '') {
        currentPage = window.digitalData.page.category.subCategory1;
    } else {
        currentPage = window.digitalData.page.category.primaryCategory;
    }

    var pageObj = dismissedPages.find(function (item) {
        return item.page === currentPage;
    });

    // If the quiz was dismissed earlier and it is less than two days
    if (pageObj && Date.now() <= pageObj.expireAt) {
        // Hide the toast
        $('.quiz-toast-wrapper').addClass('dismissed').removeClass('in-view');
        $('body').removeClass('quiz-toast-visible');
    }
});

/**
 * Checks if an element is visible within the viewport.
 * @param {jQuery} $el - The jQuery element to check.
 * @returns {boolean} True if any part of the element is visible in the viewport, false otherwise.
 */
function isElementInViewport($el) {
    if (!$el.length) return false;
    var elementTop = $el.offset().top;
    var elementBottom = elementTop + $el.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    // Checks if any part of the element is visible
    return elementBottom > viewportTop && elementTop < viewportBottom;
}

module.exports = function () {
    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);

        $(this).on('keyup click', function (e) {
            $('.site-search .cross-icon-button').toggleClass(
                'd-none',
                ($(this).val() === '' || $(this).val().trim() === '' || ($(this).val().trim().indexOf('$') >= 0) || ($(this).val().trim().indexOf('\\') >= 0))
            );

            if ($(this).val().trim() !== '' && e.which !== 40 && e.which !== 38) {
                debounceSuggestions(this, e);
            }

            $('.site-search .search-icon').toggleClass(
                'disabled',
                ($(this).val() === '' || $(this).val().trim() === '' || ($(this).val().trim().indexOf('$') >= 0) || ($(this).val().trim().indexOf('\\') >= 0))
            );
        });

        $(this).on('keydown', function (e) {
            if (e.keyCode === 13 && ($(this).val() === '' || $(this).val().trim() === '' || ($(this).val().trim().indexOf('$') >= 0) || ($(this).val().trim().indexOf('\\') >= 0))) {
                e.preventDefault();
            }
        });
    });

    $('body').on('click', function (e) {
        if (
            !$('.suggestions').has(e.target).length &&
            !$('.suggestions-wrapper-inner').has(e.target).length &&
            !$('.cross-icon-button').has(e.target).length &&
            !$(e.target).hasClass('search-field') &&
            e.target !== $('.active.rounded-circle')[0]
        ) {
            if (!$('.suggestions-wrapper').is(':visible')) {
                $('.suggestions-wrapper-inner').addClass('d-none');
                $('.newSearch').find('.search-field').attr('aria-expanded', 'false');
            } else {
                $('.suggestions').hide();
            }
        }
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 27) {
            $('.form-control.search-field.is-dirty').val('');
            $('.suggestions-wrapper').fadeOut(500);
            $('#siteMobSearch .site-search.newSearch').removeClass('focused');
            $('#siteMobSearch .overlay-div').addClass('d-none');
            $('.form-control.search-field.is-dirty').blur();
            $('.icon-button.search-icon').addClass('disabled');
            $('.icon-button.cross-icon-button').addClass('d-none');
            if (!$('.suggestions-wrapper').is(':visible')) {
                if ($('.search-suggestions-wrapper').html() !== '') {
                    $('.search-suggestions-wrapper').html('');
                    $('.default-suggestions-wrapper').removeClass('d-none');
                    $('.suggestions-wrapper-inner').addClass('d-none');
                } else {
                    $('.suggestions-wrapper-inner').addClass('d-none');
                }
                $('.newSearch').find('.search-field').attr('aria-expanded', 'false');
                $('.new-search-enabled').removeClass('focused');
                $('#siteSearch .newSearch .form-control.search-field').blur();
                $('#siteMobSearch .newSearch .form-control.search-field').blur();
                $('.overlay-div').addClass('d-none');
            }
        }

        if (!$('.suggestions-wrapper').is(':visible')) {
            if (event.key === 'Enter' || event.key === 13) {
                if ($(event.target).hasClass('cross-icon-button')) {
                    event.preventDefault();
                    if ($('.search-suggestions-wrapper').html() !== '') {
                        $('.search-suggestions-wrapper').html('');
                        $('.default-suggestions-wrapper').removeClass('d-none');
                        $('.suggestions-wrapper-inner').addClass('d-none');
                    } else {
                        $('.suggestions-wrapper-inner').addClass('d-none');
                    }
                    $('.newSearch').find('.search-field').attr('aria-expanded', 'false');
                    $('.new-search-enabled').removeClass('focused');
                    $('#siteSearch .newSearch .form-control.search-field').blur();
                    $('#siteMobSearch .newSearch .form-control.search-field').blur();
                    $('.overlay-div').addClass('d-none');
                }
            }
        }
    });

    $(window).scroll(function () {
        var seeMoreButton = $('.see-more-button');
        if (seeMoreButton.length && window.activeScrollEvent) {
            var offsetHeight = $('.see-more-button').offset().top;
            var outerHeight = $('.see-more-button').outerHeight();
            var windowHeight = $(window).height();
            var wS = $(this).scrollTop();
            var noofpagestolazyload = lazyLoadConfigs.data('noofpagestolazyload');
            if (wS > (((offsetHeight + outerHeight) - windowHeight) / 2)) {
                if (!$('.see-more-button').hasClass('block-lazy-load')) {
                    $('.see-more-button').addClass('block-lazy-load');
                    lazyLoadProducts();
                } else if (!$('.see-more-button').hasClass('page-size-updated') && (counterForLazyLoad >= noofpagestolazyload)) {
                    var seeMoreURL = $('.see-more-button').data('url');
                    var updatedURL;
                    var updatedPageSize = lazyLoadConfigs.data('updatedpagesize');
                    var index = seeMoreURL.indexOf('sz');
                    if (index) {
                        updatedURL = seeMoreURL.substring(0, index + 3) + updatedPageSize + '&updatePageSize=true';
                        $('.see-more-button').attr('data-url', updatedURL);
                    }
                    $('.see-more-button').addClass('page-size-updated');
                }

                // Prevent multiple clicks on See more button
                $('.see-more-button').off('click').on('click', function () {
                    if ($('.see-more-button').hasClass('block-multiple-clicks')) {
                        $('.see-more-button').attr('disabled', 'disabled');
                    } else {
                        $('.see-more-button').addClass('block-multiple-clicks');
                    }
                });
            }

            localStorage.setItem('cdp-scroll-pos', $(window).scrollTop());
        }

        // Check if quiz toast is configured and not dismissed by user
        if ($('.quiz-toast-wrapper').length && !$('.quiz-toast-wrapper').hasClass('dismissed')) {
            var $secondTile = $('.product-grid .product-tile').eq(1);
            if ($secondTile.length) {
                var regionTop = $secondTile.offset().top;
                var scrollTop = $(window).scrollTop();
                var gridEnd = $('.grid-footer').offset().top;
                var footerVisible = isElementInViewport($('.grid-footer'));
                var quickStartEnabled = $('.quickStartWrapper').hasClass('show');

                if (scrollTop > regionTop && scrollTop < gridEnd && !footerVisible && !quickStartEnabled && document.readyState === 'complete') {
                    setTimeout(() => {
                        $('.quiz-toast-wrapper').addClass('in-view');
                        $('body').addClass('quiz-toast-visible');
                        if ($('.add-to-wishlist-messages').hasClass('show-toast') && !$('.compare-bar-wrapper').hasClass('visible')) {
                            var $target = $('.quiz-toast-wrapper');
                            var $toast = $('.add-to-wishlist-messages');

                            var targetHeight = $target.outerHeight();
                            var topValue = targetHeight + 16 + 'px';
                            $toast[0].style.setProperty('bottom', topValue, 'important');
                            setTimeout(() => {
                                $('.add-to-wishlist-messages').removeClass('show-toast');
                                $toast[0].style.setProperty('bottom', '-100px');
                            }, 6000);
                        }
                    }, 600);
                } else {
                    $('.quiz-toast-wrapper').removeClass('in-view');
                    $('body').removeClass('quiz-toast-visible');
                }
            }
        }
    });

    $('body').on('touchend', function (e) {
        if (
            !$('.suggestions').has(e.target).length &&
            !$('.cross-icon-button').has(e.target).length &&
            !$(e.target).hasClass('search-field')
        ) {
            if (!$('.suggestions-wrapper').is(':visible')) {
                $('.suggestions-wrapper-new').hide();
            } else {
                $('.suggestions').hide();
            }
            toggleSuggestionsIcon('search');
            tearDownSuggestions();
        }
    });

    $('.newSearch .cross-icon-button').on('click', function () {
        $('.suggestions-wrapper-new').show();
    });

    $('body').on('click touchend', '.cross-icon-button', function () {
        if (!$('.suggestions-wrapper').is(':visible')) {
            $('.suggestions-wrapper-inner').addClass('d-none');
            $('.newSearch').find('.search-field').attr('aria-expanded', 'false');
        } else {
            $('.suggestions').hide();
        }

        $('input.search-field').val('');
        tearDownSuggestions();
        $(this).addClass('d-none');
        if ($('.newSearch').length > 0) { // Keep focus on search bar when 'x' icon is clicked if newSearch class exists
            $('input.search-field').focus();
        }
    });

    /** The following monitors for changes in the number of products added
     ** to product grid and updates number of items info above the 'see more' button
     **/
    if ($('#product-search-results').length > 0 && $('.product-grid').length) {
        var productGrid = $('.product-grid')[0];

        var productGridObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                var newNodes = mutation.addedNodes;
                if (newNodes !== null) {
                    setMoreNumberOfItems();
                }
            });
        });

        var productGridObserverConfig = {
            attributes: true,
            childList: true,
            characterData: true
        };

        productGridObserver.observe(productGrid, productGridObserverConfig);
    }

    pdSwiperFilter.init();

    $(window).on('load', function () {
        setTimeout(function () {
            if ($('.see-more-button').length > 0) {
                var queryString = window.location.search;
                var urlParams = new URLSearchParams(queryString);
                if (urlParams.get('sz') !== null) {
                    var productstolazyload = lazyLoadConfigs.data('productstolazyloaddesktop');
                    if (mobileMediaQuery.matches) {
                        productstolazyload = lazyLoadConfigs.data('productstolazyloadmobile');
                    }
                    counterForLazyLoad = urlParams.get('sz') / productstolazyload;

                    if (localStorage.getItem('cdp-scroll-pos') != null) {
                        $('html, body').stop().animate({ scrollTop: localStorage.getItem('cdp-scroll-pos') }, 500, 'swing', function () {
                            window.activeScrollEvent = true;
                        });
                    }
                } else {
                    window.activeScrollEvent = true;
                }
            }
        }, 300);

        $('.form-control.search-field').on('input', function () {
            var Searchquery = $(this).val();
            var suggestionsWrapper = $('.suggestions-wrapper');
            if (Searchquery.length >= 3) {
                suggestionsWrapper.attr('aria-live', 'assertive');
                $(this).attr('aria-expanded', 'true');
            } else {
                suggestionsWrapper.removeAttr('aria-live');
                $(this).attr('aria-expanded', 'false');
            }
        });

        if (!$('.suggestions-wrapper').is(':visible')) {
            $('.clear-all-recent').on('click', function () {
                localStorage.setItem('searchRecentTerms', '');
                $('.default-recent-searches').addClass('d-none');
                $('.default-recent-searches .col-7, .clear-all-recent, .default-recent-searches a').attr('tabindex', '-1');
            });
            $('.site-search form').off().on('submit', function (e) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                setTimeout(function () {
                    var searchStringVal = $(e.currentTarget).find('.form-control.search-field').val();
                    var searchRecentTerms = localStorage.getItem('searchRecentTerms');
                    if (typeof (searchRecentTerms) !== 'undefined' && searchRecentTerms !== null) {
                        searchRecentTerms = searchStringVal + '||' + searchRecentTerms;
                    } else {
                        searchRecentTerms = searchStringVal;
                    }
                    if (searchTermSubmitted) {
                        localStorage.setItem('searchRecentTerms', searchRecentTerms);
                        if ($('.suggestions').data('registereduser')) {
                            $.ajax({
                                url: endpointsavesuggestions,
                                method: 'POST',
                                data: { searchRecentTerms: searchRecentTerms },
                                error: function () {
                                    $.spinner().stop();
                                }
                            });
                        }
                    }
                    searchTermSubmitted = false;
                    $('.default-recent-searches').removeClass('d-none');
                    // Continue the form submit
                    e.currentTarget.submit();
                }, 300);
            });
        }

        // A11y handling for toaster
        $('.quiz-toast-wrapper .icon-close').on('keydown', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                if ($('.toggle-switch-input:visible').length) {
                    $('.toggle-switch-input').focus().addClass('tabbed');
                } else {
                    $('.product-grid').find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible, :enabled').first()
                    .focus();
                }
            }
        });

        $('.quiz-toast-wrapper .quiz-cta').on('keydown', function (e) {
            if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                $('select.sort-custom-select').focus();
            }
        });
    });
};

// Display color titles in tooltip when hover/tab on color swatches
$(document).tooltip({
    selector: '.swatchAnchor[data-toggle="tooltip"]',
    customClass: 'color-swatch-tooltip'
});

$(document).on('focusout', '.swatchAnchor[data-toggle="tooltip"]', function () {
    $(this).tooltip('hide');
});

$('.quiz-toast-wrapper .icon-close, .quiz-toast-wrapper .quiz-cta').on('click', function () {
    $('.quiz-toast-wrapper').addClass('dismissed').removeClass('in-view');
    $('body').removeClass('quiz-toast-visible');

    // Get the array from localStorage or initialize as empty
    var dismissedPages = JSON.parse(window.localStorage.getItem('quiz-toaster-dismissed-pages') || '[]');

    // Determine current page
    var currentPage;
    if (window.digitalData.page.category.subCategory2 !== '') {
        currentPage = window.digitalData.page.category.subCategory2;
    } else if (window.digitalData.page.category.subCategory1 !== '') {
        currentPage = window.digitalData.page.category.subCategory1;
    } else {
        currentPage = window.digitalData.page.category.primaryCategory;
    }

    // Set expiry time for 2 days
    var expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 2);
    var expireAt = expireDate.getTime();

    // Check if current page already exists in the array
    var pageObj = dismissedPages.find(function (item) {
        return item.page === currentPage;
    });

    if (pageObj) {
        pageObj.expireAt = expireAt; // Update expiry if already present
    } else {
        dismissedPages.push({ page: currentPage, expireAt: expireAt });
    }

    // Save updated array back to localStorage
    window.localStorage.setItem('quiz-toaster-dismissed-pages', JSON.stringify(dismissedPages));
});
